import styled from 'styled-components';
import { motion } from 'framer-motion';

export const StyledButton = styled(motion.button)`
  padding: ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.xl};
  font-size: ${({ theme }) => theme.typography.fontSize.base};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  margin: ${({ theme }) => theme.spacing.lg} 0;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background: linear-gradient(135deg, #2563EB, #1E40AF);
  border: none;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.normal};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: ${({ theme }) => theme.shadows.md};
  position: relative;
  overflow: hidden;
  min-width: 120px;
  opacity: ${({ $isActive }) => $isActive ? '1' : '0.6'};
  filter: ${({ $isActive }) => $isActive ? 'saturate(1)' : 'saturate(0.7)'};
  background: ${({ $isActive }) => $isActive 
    ? 'linear-gradient(135deg, #3B82F6, #2563EB)' 
    : 'linear-gradient(135deg, #2563EB, #1E40AF)'};
  box-shadow: ${({ $isActive, theme }) => $isActive ? theme.shadows.lg : theme.shadows.md};

  &:hover:not(:disabled) {
    opacity: 1;
    filter: saturate(1);
    background: linear-gradient(135deg, #3B82F6, #2563EB);
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows.lg};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.lg};
    font-size: ${({ theme }) => theme.typography.fontSize.sm};
    min-width: 100px;
  }
`;

export const IconButton = styled(StyledButton)`
  padding: ${({ theme }) => theme.spacing.sm};
  min-width: auto;
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    width: 36px;
    height: 36px;
  }
`;

